import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

interface GoogleApisWindowExt extends Window {
    initMap: () => void;
    isLoaded: boolean;
}
declare let window: GoogleApisWindowExt;

@Injectable({
    providedIn: 'root',
})
export class GoogleApisScriptInjectorService {
    private readonly _googleScriptLoaded$ = new BehaviorSubject<boolean>(false);

    public isGoogleApiScriptLoaded(): Observable<boolean> {
        return this._googleScriptLoaded$.asObservable();
    }

    public ensureGoogleApiScriptIsLoaded(key: string): void {
        if (this._googleScriptLoaded$.getValue()) {
            return;
        }

        const timer = setInterval(
            ((): void => {
                if (window.isLoaded === true) {
                    clearInterval(timer);

                    this._googleScriptLoaded$.next(true);
                }
            }).bind(this),
            50,
        );

        this._loadScript(key);
    }

    private _loadScript(key: string): void {
        const node = document.createElement('script');
        node.src = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places&loading=async&callback=initMap`;
        node.type = 'text/javascript';
        node.async = true;
        node.setAttribute('data-usercentrics', 'Google Maps');

        window.initMap = (): void => {
            window.isLoaded = true;
        };

        document.getElementsByTagName('head')[0].appendChild(node);
    }
}
